// extracted by mini-css-extract-plugin
export default {"nutrientTable":"l8SQelPwPKcJvCB7NPWA"};